<template>
    <div class="pageNotice-m">
        <div class="jobMain">
            <el-row :gutter="10" class="notice-row" type="flex">
                <el-col :span="7" class="notice-col">
                    <div class="notice-lef">
                        <ul class="notice-lef-list">
                            <li :class="{active: activeTab === 'approval'}" @click="switchTab('approval')">
                                审核消息
                            </li>
                            <li :class="{active: activeTab === 'site'}" @click="switchTab('site')">
                                后续通知
                                <span class="notice-li-num" v-if="siteUnreadNum > 0">{{ siteUnreadNum > 99 ? '99+' : siteUnreadNum }}</span>
                            </li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="17" class="notice-col">
                    <!-- 审核消息 -->
                    <div class="notice-rig" v-show="activeTab === 'approval'">
                        <div class="notice-rt">
                            <div class="notice-rtle">审核消息</div>
                            <div class="notice-rt-actions">
                                <span class="notice-rtr"><i class="el-icon-circle-check"></i> 全部已读</span>
                            </div>
                        </div>
                        <div class="notice-mlist">
                            <ul>
                                <li v-if="noticeData.newD && noticeData.newD.length>0">
                                    <div class="notice-mli-t notice-mli-tnew">最新消息</div>
                                    <div class="notice-mli-b notice-mli-bnew clearfix" v-for="(item,index) in noticeData.newD" :key="'n'+index">
                                        <div class="notice-mli-bl"><span class="notice-mli-bl-dot"></span></div>
                                        <div class="notice-mli-bm">
                                            <div class="notice-mli-bmt">{{item.messageTitle}} <el-tag :type="tagStatus[item.approvalStatus]" size="small"><i :class="iconStatus[item.approvalStatus]"></i> {{ appStatus[item.approvalStatus] }}</el-tag></div>
                                            <div class="notice-mli-bmb"><span class="notice-mli-bmb-box">潞安化工集团有限公司</span>· {{ item.sendTime }}</div>
                                            <div class="notice-mli-preview" v-if="showApprovalComment(item)">审批意见：{{ displayApprovalComment(item) }}</div>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="noticeData.oldD && noticeData.oldD.length>0">
                                    <div class="notice-mli-t">历史消息</div>
                                    <div class="notice-mli-b clearfix" v-for="(item,index) in noticeData.oldD" :key="'o'+index">
                                        <div class="notice-mli-bm">
                                            <div class="notice-mli-bmt">{{item.messageTitle}} <el-tag :type="tagStatus[item.approvalStatus]" size="small"><i :class="iconStatus[item.approvalStatus]"></i> {{ appStatus[item.approvalStatus] }}</el-tag></div>
                                            <div class="notice-mli-bmb"><span class="notice-mli-bmb-box">潞安化工集团有限公司</span>· {{ item.sendTime }}</div>
                                            <div class="notice-mli-preview" v-if="showApprovalComment(item)">审批意见：{{ displayApprovalComment(item) }}</div>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="(!noticeData.newD || noticeData.newD.length===0) && (!noticeData.oldD || noticeData.oldD.length===0)" class="notice-empty">暂无审核消息</li>
                            </ul>
                        </div>
                    </div>

                    <!-- 后续通知（站内信） -->
                    <div class="notice-rig" v-show="activeTab === 'site'">
                        <div class="notice-rt">
                            <div class="notice-rtle">后续通知</div>
                            <div class="notice-rt-actions">
                                <span class="notice-rtr" @click="markSiteAllRead" v-if="siteUnreadNum > 0"><i class="el-icon-circle-check"></i> 全部已读</span>
                            </div>
                            <el-button v-if="isAdmin" class="notice-rt-publish" type="danger" size="small" icon="el-icon-edit" @click="publishDialogVisible = true">发布站内公告</el-button>
                            <el-dropdown v-if="isAdmin" trigger="hover" placement="bottom-end" @command="handlePrivateCommand">
                                <el-button class="notice-rt-private" type="primary" size="small" plain icon="el-icon-message">
                                    个性化发布私信 <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="download">
                                        <i class="el-icon-download"></i> 下载私信模板
                                    </el-dropdown-item>
                                    <el-dropdown-item command="import">
                                        <i class="el-icon-upload2"></i> 导入私信模板
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <input
                                ref="privateImportInput"
                                type="file"
                                accept=".xlsx,.xls"
                                style="display: none;"
                                @change="onPrivateImportChange"
                            />
                        </div>
                        <div class="notice-mlist">
                            <ul>
                                <li v-if="siteNoticeData.newD && siteNoticeData.newD.length>0">
                                    <div class="notice-mli-t notice-mli-tnew">最新消息</div>
                                    <div class="notice-mli-b notice-mli-bnew clearfix"
                                         v-for="item in siteNoticeData.newD"
                                         :key="'sn'+item.id"
                                         @click="openSiteDetail(item)">
                                        <div class="notice-mli-bl"><span class="notice-mli-bl-dot"></span></div>
                                        <div class="notice-mli-br"><i class="el-icon-arrow-right"></i></div>
                                        <div class="notice-mli-bm">
                                            <div class="notice-mli-bmt">{{ item.title }}</div>
                                            <div class="notice-mli-bmb">
                                                <span class="notice-mli-bmb-box">{{ item.publisherName || '系统通知' }}</span>· {{ item.publishTime }}
                                            </div>
                                            <div class="notice-mli-preview">{{ contentPreview(item.content) }}</div>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="siteNoticeData.oldD && siteNoticeData.oldD.length>0">
                                    <div class="notice-mli-t">历史消息</div>
                                    <div class="notice-mli-b clearfix"
                                         v-for="item in siteNoticeData.oldD"
                                         :key="'so'+item.id"
                                         @click="openSiteDetail(item)">
                                        <div class="notice-mli-br"><i class="el-icon-arrow-right"></i></div>
                                        <div class="notice-mli-bm">
                                            <div class="notice-mli-bmt">{{ item.title }}</div>
                                            <div class="notice-mli-bmb">
                                                <span class="notice-mli-bmb-box">{{ item.publisherName || '系统通知' }}</span>· {{ item.publishTime }}
                                            </div>
                                            <div class="notice-mli-preview">{{ contentPreview(item.content) }}</div>
                                        </div>
                                    </div>
                                </li>
                                <li v-if="(!siteNoticeData.newD || siteNoticeData.newD.length===0) && (!siteNoticeData.oldD || siteNoticeData.oldD.length===0)" class="notice-empty">暂无后续通知</li>
                            </ul>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>

        <!-- 选择考试批次下载私信模板 -->
        <el-dialog title="下载私信模板" :visible.sync="batchDialogVisible" width="480px" @close="resetBatchDialog">
            <el-form label-width="90px">
                <el-form-item label="考试批次" required>
                    <el-select v-model="selectedEntranceId" placeholder="请选择考试批次" style="width: 100%;" :loading="entranceLoading">
                        <el-option
                            v-for="item in entranceList"
                            :key="item.id"
                            :label="item.entranceName"
                            :value="item.id"
                        />
                    </el-select>
                </el-form-item>
                <div class="batch-dialog-tip">将导出该批次下「已提交报名且审批通过」考生的私信导入模板。</div>
            </el-form>
            <span slot="footer">
                <el-button @click="batchDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="templateDownloadLoading" :disabled="!selectedEntranceId" @click="confirmDownloadTemplate">确认下载</el-button>
            </span>
        </el-dialog>

        <!-- 个性化私信导入预览 -->
        <el-dialog
            title="个性化私信导入确认"
            :visible.sync="privateImportPreviewVisible"
            width="88%"
            top="6vh"
            custom-class="private-import-dialog"
            @closed="resetPrivateImportPreview"
        >
            <div v-if="privateImportErrors.length" class="import-error-box">
                <div class="import-error-title"><i class="el-icon-warning-outline"></i> 以下问题需修正后再导入：</div>
                <ul>
                    <li v-for="(err, idx) in privateImportErrors" :key="'perr-' + idx">{{ err }}</li>
                </ul>
            </div>
            <div v-else class="private-import-wrap">
                <div class="private-import-summary">
                    <span class="private-import-summary-num">{{ privateImportPreviewList.length }}</span>
                    <span>名考生待发送个性化私信，请逐条核对公告内容</span>
                </div>
                <div class="private-import-list">
                    <div v-for="(item, index) in privateImportPreviewList" :key="item.applicationId || index" class="private-import-card">
                        <div class="private-import-head">
                            <span class="private-import-index">{{ index + 1 }}</span>
                            <div class="private-import-main">
                                <div class="private-import-name">{{ item.applicantName || '—' }}</div>
                                <div class="private-import-meta">报名ID {{ item.applicationId }} · {{ item.idCardNumber || '—' }}</div>
                                <div class="private-import-meta">{{ item.positionName || '—' }} · {{ item.entranceName || '—' }}</div>
                            </div>
                        </div>
                        <div class="private-import-content">{{ item.content }}</div>
                    </div>
                </div>
            </div>
            <span slot="footer">
                <el-button @click="privateImportPreviewVisible = false">取消</el-button>
                <el-button
                    type="primary"
                    :disabled="privateImportErrors.length > 0 || !privateImportPayload.length"
                    :loading="privateImportSubmitting"
                    @click="confirmPrivateImport"
                >确认发送（{{ privateImportPreviewList.length }} 人）</el-button>
            </span>
        </el-dialog>

        <!-- 发布站内公告 -->
        <el-dialog title="发布站内公告" :visible.sync="publishDialogVisible" width="560px" @close="resetPublishForm">
            <el-form :model="publishForm" :rules="publishRules" ref="publishForm" label-width="80px">
                <el-form-item label="标题" prop="title">
                    <el-input v-model="publishForm.title" maxlength="200" show-word-limit placeholder="请输入通知标题"></el-input>
                </el-form-item>
                <el-form-item label="正文" prop="content">
                    <el-input type="textarea" v-model="publishForm.content" :rows="8" maxlength="5000" show-word-limit placeholder="请输入通知正文（纯文字）"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="publishDialogVisible = false">取消</el-button>
                <el-button type="primary" :loading="publishLoading" @click="submitPublish">发布</el-button>
            </span>
        </el-dialog>

        <!-- 站内信详情 -->
        <el-dialog :title="siteDetail.title" :visible.sync="detailDialogVisible" width="600px">
            <div class="site-detail-meta">
                <span class="notice-mli-bmb-box">{{ siteDetail.publisherName || '系统通知' }}</span>
                <span class="site-detail-time">· {{ siteDetail.publishTime }}</span>
            </div>
            <div class="site-detail-content">{{ siteDetail.content }}</div>
            <span slot="footer">
                <el-button v-if="isAdmin" type="danger" plain @click="deleteSiteMessage">删除</el-button>
                <el-button type="primary" @click="detailDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
import {
    downloadPrivateMessageTemplate,
    parsePrivateMessageWorkbook,
    readPrivateMessageFile,
} from '../utils/siteMessageImport';

export default {
    name: 'PageNotice',
    data() {
        return {
            activeTab: 'approval',
            userInfo: null,
            isAdmin: false,
            noticeData: { newD: [], oldD: [] },
            siteNoticeData: { newD: [], oldD: [] },
            siteUnreadNum: 0,
            appStatus: {1: "待补充资料",2: "审批中",3: "已通过",4: "审核不通过"},
            tagStatus: {1: "primary",2: "primary",3: "success",4: "danger"},
            iconStatus: {1: "el-icon-refresh-right",2: "el-icon-refresh-right",3: "el-icon-check",4: "el-icon-close"},
            publishDialogVisible: false,
            publishLoading: false,
            publishForm: { title: '', content: '' },
            publishRules: {
                title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
                content: [{ required: true, message: '请输入正文', trigger: 'blur' }],
            },
            detailDialogVisible: false,
            siteDetail: { id: null, title: '', content: '', publisherName: '', publishTime: '' },
            batchDialogVisible: false,
            entranceList: [],
            entranceLoading: false,
            selectedEntranceId: null,
            templateDownloadLoading: false,
            privateImportPreviewVisible: false,
            privateImportPreviewList: [],
            privateImportPayload: [],
            privateImportErrors: [],
            privateImportSubmitting: false,
        }
    },
    mounted() {
        document.title = '潞安招聘-消息通知';
        this.loadUserInfo();
        this.getNotice();
    },
    methods: {
        authHeaders() {
            return { 'Authorization': Cookies.get('reqToKen') };
        },
        loadUserInfo() {
            if (!Cookies.get('reqToKen')) return;
            axios.get('/zhaopinapi/users/info', { headers: this.authHeaders() }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.userInfo = _d.data;
                    this.isAdmin = this.userInfo.roleId !== 2;
                    this.prefetchSiteUnread();
                }
            }).catch(() => {});
        },
        prefetchSiteUnread() {
            axios.get('/zhaopinapi/site-message/list', { headers: this.authHeaders() }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.siteUnreadNum = _d.data.filter(item => !item.userReadFlag).length;
                }
            }).catch(() => {});
        },
        switchTab(tab) {
            this.activeTab = tab;
            if (tab === 'approval') {
                this.noticeData = { newD: [], oldD: [] };
                this.getNotice();
            } else {
                this.siteNoticeData = { newD: [], oldD: [] };
                this.getSiteMessages();
            }
        },
        handlePrivateCommand(command) {
            if (command === 'download') {
                this.openBatchDialog();
            } else if (command === 'import') {
                this.triggerPrivateImport();
            }
        },
        openBatchDialog() {
            this.batchDialogVisible = true;
            this.loadEntranceList();
        },
        resetBatchDialog() {
            this.selectedEntranceId = null;
            this.templateDownloadLoading = false;
        },
        loadEntranceList() {
            if (this.entranceList.length) {
                return Promise.resolve(this.entranceList);
            }
            this.entranceLoading = true;
            return axios.get('/zhaopinapi/entrance/find-all', {
                headers: this.authHeaders(),
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    this.entranceList = (data.data || []).slice().sort((a, b) => (a.entranceType ?? 0) - (b.entranceType ?? 0));
                    return this.entranceList;
                }
                this.$message.error((data && data.message) || '加载考试批次失败');
                return [];
            }).catch(() => {
                this.$message.error('加载考试批次失败');
                return [];
            }).finally(() => {
                this.entranceLoading = false;
            });
        },
        confirmDownloadTemplate() {
            const entrance = this.entranceList.find((item) => item.id === this.selectedEntranceId);
            if (!entrance) {
                this.$message.warning('请选择考试批次');
                return;
            }
            const entranceType = Number(entrance.entranceType);
            this.templateDownloadLoading = true;
            axios.get('/zhaopinapi/site-message/private-message/candidates', {
                headers: this.authHeaders(),
                params: { entranceType },
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    const list = data.data || [];
                    if (!list.length) {
                        this.$message.warning('该批次下暂无已审批通过的考生');
                        return;
                    }
                    downloadPrivateMessageTemplate(list, entrance.entranceName);
                    this.$message.success(`已下载 ${list.length} 名考生私信模板`);
                    this.batchDialogVisible = false;
                } else {
                    this.$message.error((data && data.message) || '下载失败');
                }
            }).catch(() => {
                this.$message.error('下载失败');
            }).finally(() => {
                this.templateDownloadLoading = false;
            });
        },
        triggerPrivateImport() {
            if (this.$refs.privateImportInput) {
                this.$refs.privateImportInput.value = '';
                this.$refs.privateImportInput.click();
            }
        },
        onPrivateImportChange(event) {
            const file = event.target.files && event.target.files[0];
            if (!file) {
                return;
            }
            readPrivateMessageFile(file).then((workbook) => {
                const parsed = parsePrivateMessageWorkbook(workbook);
                this.privateImportPreviewList = parsed.previewList;
                this.privateImportPayload = parsed.payload;
                this.privateImportErrors = parsed.errors;
                this.privateImportPreviewVisible = true;
            }).catch(() => {
                this.$message.error('解析 Excel 失败，请使用系统模板');
            });
        },
        resetPrivateImportPreview() {
            this.privateImportPreviewList = [];
            this.privateImportPayload = [];
            this.privateImportErrors = [];
            this.privateImportSubmitting = false;
        },
        confirmPrivateImport() {
            if (!this.privateImportPayload.length || this.privateImportErrors.length) {
                return;
            }
            this.privateImportSubmitting = true;
            axios.post('/zhaopinapi/site-message/private-message/import/batch', this.privateImportPayload, {
                headers: this.authHeaders(),
            }).then((res) => {
                const data = res.data;
                if (data && data.success) {
                    const result = data.data || {};
                    const failCount = result.failCount || 0;
                    const successCount = result.successCount || 0;
                    if (failCount > 0) {
                        const errors = (result.errors || []).join('\n');
                        this.$alert(errors || '部分考生发送失败', '发送结果', { type: 'warning' }).catch(() => {});
                    } else {
                        this.$message.success(`成功向 ${successCount} 名考生发送个性化私信`);
                        this.privateImportPreviewVisible = false;
                    }
                    this.getSiteMessages();
                } else {
                    this.$message.error((data && data.message) || '发送失败');
                }
            }).catch((error) => {
                const msg = (error.response && error.response.data && error.response.data.message) || '发送失败';
                this.$message.error(msg);
            }).finally(() => {
                this.privateImportSubmitting = false;
            });
        },
        getNotice() {
            if (!Cookies.get('reqToKen')) return;
            axios.get('/zhaopinapi/application-approval-notification/user', {
                headers: this.authHeaders(),
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    const newD = [], oldD = [];
                    if (_d.data && _d.data.length > 0) {
                        _d.data.forEach(item => {
                            if (item.userViewFlag) oldD.push(item);
                            else newD.push(item);
                        });
                    }
                    this.noticeData = { newD, oldD };
                } else {
                    this.$message.error(_d.message);
                }
            }).catch((error) => { console.log(error); });
        },
        getSiteMessages() {
            if (!Cookies.get('reqToKen')) return;
            axios.get('/zhaopinapi/site-message/list', {
                headers: this.authHeaders(),
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    const newD = [], oldD = [];
                    let unread = 0;
                    if (_d.data && _d.data.length > 0) {
                        _d.data.forEach(item => {
                            if (item.userReadFlag) oldD.push(item);
                            else { newD.push(item); unread++; }
                        });
                    }
                    this.siteNoticeData = { newD, oldD };
                    this.siteUnreadNum = unread;
                } else {
                    this.$message.error(_d.message);
                }
            }).catch((error) => { console.log(error); });
        },
        contentPreview(content) {
            if (!content) return '';
            const text = String(content).replace(/\s+/g, ' ');
            return text.length > 60 ? text.slice(0, 60) + '...' : text;
        },
        displayApprovalComment(item) {
            return String(item.approvalComment || item.approval_comment || '').trim();
        },
        showApprovalComment(item) {
            return Number(item.approvalStatus) === 4 && !!this.displayApprovalComment(item);
        },
        openSiteDetail(item) {
            axios.get('/zhaopinapi/site-message/' + item.id, {
                headers: this.authHeaders(),
            }).then((res) => {
                const _d = res.data;
                if (_d.success && _d.data) {
                    this.siteDetail = _d.data;
                    this.detailDialogVisible = true;
                    this.getSiteMessages();
                } else {
                    this.$message.error(_d.message || '加载失败');
                }
            }).catch(() => { this.$message.error('加载失败'); });
        },
        markSiteAllRead() {
            axios.put('/zhaopinapi/site-message/read-all', null, {
                headers: this.authHeaders(),
            }).then((res) => {
                const _d = res.data;
                if (_d.success) {
                    this.$message.success('已全部标记为已读');
                    this.getSiteMessages();
                } else {
                    this.$message.error(_d.message);
                }
            }).catch(() => { this.$message.error('操作失败'); });
        },
        resetPublishForm() {
            this.publishForm = { title: '', content: '' };
            if (this.$refs.publishForm) this.$refs.publishForm.resetFields();
        },
        submitPublish() {
            this.$refs.publishForm.validate((valid) => {
                if (!valid) return;
                this.publishLoading = true;
                axios.post('/zhaopinapi/site-message/publish', this.publishForm, {
                    headers: this.authHeaders(),
                }).then((res) => {
                    const _d = res.data;
                    if (_d.success) {
                        this.$message.success('发布成功');
                        this.publishDialogVisible = false;
                        this.resetPublishForm();
                        this.getSiteMessages();
                    } else {
                        this.$message.error(_d.message);
                    }
                }).catch(() => { this.$message.error('发布失败'); })
                .finally(() => { this.publishLoading = false; });
            });
        },
        deleteSiteMessage() {
            if (!this.siteDetail.id) return;
            this.$confirm('确定删除该站内信吗？', '提示', { type: 'warning' }).then(() => {
                axios.delete('/zhaopinapi/site-message/delete/' + this.siteDetail.id, {
                    headers: this.authHeaders(),
                }).then((res) => {
                    const _d = res.data;
                    if (_d.success) {
                        this.$message.success('删除成功');
                        this.detailDialogVisible = false;
                        this.getSiteMessages();
                    } else {
                        this.$message.error(_d.message);
                    }
                }).catch(() => { this.$message.error('删除失败'); });
            }).catch(() => {});
        },
    }
}
</script>

<style scoped>
    .pageNotice-m{
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        height: 100%;
        padding: 12px 0;
        box-sizing: border-box;
    }
    .pageNotice-m .jobMain{
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        height: 100%;
    }
    .jobMain{width: 80%; max-width: 1400px; margin: 0 auto;}
    @media (max-width: 1400px) and (min-width: 1300px) {
        .jobMain{width: 90%;  margin: 0 auto;}
    }
    @media (max-width: 1300px) {
        .jobMain{width: 100%; min-width: 1150px;}
    }
    .notice-row{
        flex: 1;
        min-height: 480px;
        height: 100%;
    }
    .notice-row >>> .el-col.notice-col{
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .notice-lef{
        padding: 24px;
        background: #fff;
        height: 100%;
        box-sizing: border-box;
    }
    .notice-rig{
        background: #fff;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        overflow: visible;
    }
    .notice-rt{
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
        border-bottom: 1px solid #F3F4F6;
        background: rgba(249, 250, 251, 0.50);
        padding: 18px 24px;
        position: relative;
        z-index: 2;
        overflow: visible;
    }
    .notice-rtle{font-size: 18px; color: #1E2939; line-height: 32px; font-weight: bold; flex-shrink: 0;}
    .notice-rt-actions{
        display: flex;
        align-items: center;
        flex-shrink: 0;
    }
    .notice-rtr{
        font-size: 12px;
        color: #6A7282;
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        line-height: 32px;
    }
    .notice-rtr i{margin-right: 4px; font-size: 14px;}
    .notice-rt-publish{margin-left: auto; flex-shrink: 0;}
    .notice-rt-private{margin-left: 8px; flex-shrink: 0;}
    .notice-mlist{
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .notice-lef-list{list-style: none; margin: 0; padding: 0;}
    .notice-lef-list li{border-left: 2px solid #fff; padding: 10px 24px; display: block; margin-bottom: 5px; line-height: 28px; font-size: 18px; color: #333333; text-align: center; cursor: pointer; position: relative;}
    .notice-lef-list li.active{border-left: 2px solid #E60012; background: #FFE9EB;}
    .notice-lef-list li:hover{border-left: 2px solid #E60012; background: #FFE9EB;}
    .notice-li-num{position: absolute; height: 20px; line-height: 18px; border-radius: 10px; padding: 0 7px; background: #E7000B; color: #fff; font-size: 12px; right: 10px; top: 13px;}
    .batch-dialog-tip{font-size: 12px; color: #6A7282; line-height: 20px; padding-left: 90px;}
    .import-error-box{border: 1px solid #FDE68A; background: #FFFBEB; border-radius: 8px; padding: 12px 16px; max-height: calc(85vh - 160px); overflow: auto;}
    .import-error-title{font-weight: bold; color: #92400E; margin-bottom: 8px;}
    .import-error-box ul{margin: 0; padding-left: 18px; color: #92400E;}
    .private-import-wrap{display: flex; flex-direction: column; min-height: 360px;}
    .private-import-summary{display: flex; align-items: center; gap: 8px; margin-bottom: 16px; padding: 12px 16px; border-radius: 10px; background: #EFF6FF; border: 1px solid #DBEAFE; color: #1E3A8A; font-size: 14px;}
    .private-import-summary-num{font-size: 22px; font-weight: bold; color: #E7000B; line-height: 1;}
    .private-import-list{max-height: calc(85vh - 220px); overflow: auto; padding-right: 4px;}
    .private-import-card{border: 1px solid #E5E7EB; border-radius: 12px; background: #FFF; margin-bottom: 12px; overflow: hidden;}
    .private-import-head{display: flex; gap: 12px; padding: 14px 16px; background: #F9FAFB; border-bottom: 1px solid #E5E7EB;}
    .private-import-index{flex: 0 0 28px; height: 28px; line-height: 28px; text-align: center; border-radius: 50%; background: #E7000B; color: #fff; font-weight: bold; font-size: 13px;}
    .private-import-main{flex: 1; min-width: 0;}
    .private-import-name{font-size: 16px; font-weight: bold; color: #111827;}
    .private-import-meta{margin-top: 4px; font-size: 12px; color: #6B7280;}
    .private-import-content{padding: 14px 16px; white-space: pre-wrap; line-height: 1.7; color: #364153; font-size: 14px;}
    /deep/ .private-import-dialog .el-dialog__body{padding: 16px 24px 8px; max-height: calc(92vh - 130px); overflow: hidden;}
    .notice-mlist{padding: 0 24px 16px;}
    .notice-mlist ul{margin: 0; padding: 0; list-style: none;}
    .notice-mlist ul li{padding: 24px 0;}
    .notice-mli-t{height: 16px; line-height: 16px; margin-bottom: 16px; border-left: 4px solid #D1D5DC; padding-left: 12px; font-size: 14px; font-weight: bold;}
    .notice-mli-tnew{border-left: 4px solid #E7000B;}
    .notice-mli-b{border-radius: 10px; border-bottom: 1px solid #F3F4F6; opacity: 0.8; padding: 20px; color: #364153; margin-bottom: 8px; cursor: pointer;}
    .notice-mli-b:hover{background: rgba(254, 242, 242, 1);}
    .notice-mli-bnew{border-bottom: 1px solid #F3F4F6; background: rgba(254, 242, 242, 0.30); color: #101828;}
    .notice-mli-bl{float: left; padding-top: 18px; width: 20px;}
    .notice-mli-bl-dot{width: 4px; height: 4px; border-radius: 2px; background: #E7000B; display: block;}
    .notice-mli-br{float: right; padding-top: 10px; width: 20px;}
    .notice-mli-bm{margin: 0 20px; line-height: 20px; font-size: 12px;}
    .notice-mli-bmt{font-weight: bold; font-size: 14px;}
    .notice-mli-bmb{color: #99A1AF; margin-top: 6px;}
    .notice-mli-bmb-box{border-radius: 4px; background: #F3F4F6; height: 20px; line-height: 20px; display: inline-block; padding: 0 10px; margin-right: 10px;}
    .notice-mli-preview{color: #6A7282; margin-top: 8px; font-size: 12px; line-height: 18px;}
    .notice-empty{text-align: center; color: #99A1AF; padding: 48px 0 !important;}
    .site-detail-meta{margin-bottom: 16px; color: #6A7282; font-size: 13px;}
    .site-detail-time{margin-left: 4px;}
    .site-detail-content{white-space: pre-wrap; line-height: 1.8; color: #364153; font-size: 14px; min-height: 80px;}
    .clearfix:after,.clearfix:before{clear: both; content: ""; display: block; line-height: 0;}
</style>
